import * as React from 'react';
import {ISolution} from "../../data/SolutionDataSource";
import {IBundle} from "../../data/BundleData";
import {SecondaryBar} from "../widgets/SecondaryBar";

import './VideoCollection.pcss';
import {PrimaryLayout} from "../widgets/PrimaryLayout";
import {BundleCard} from "../widgets/BundleCard";
import {SolutionOverview} from "../solution/SolutionOverview";
import {DashboardSolution} from "../../data/entities/DashboardSolution";
import {FeedItemEntity} from "../../data/entities/FeedItemEntity";

interface Props {
  dashboardSolution:DashboardSolution;
  solution:ISolution;
  onSelectBundle:(bundle:IBundle)=>void;
  onBack:()=>void;
  feedItems:FeedItemEntity[];
}

export const VideoCollection = (props:Props) =>
  <PrimaryLayout className={"video-collection"}>
    <SecondaryBar title={props.solution.name} subTitle={props.solution.subTitle} buttonAction={props.onBack} buttonLabel={"Back to Dashboard"}/>
    <div className={"pl-inner"}>
      <div className={"topper"}>
        <SolutionOverview dashboardSolution={props.dashboardSolution} />
      </div>
      <div className={"vc-container"}>
        <ul className={"reset"} aria-label={"Videos"}>
          {props.solution.bundles.map(bundle=>{
            const feedItemsWithPoints = props.feedItems.filter(f=>f.bundleId===bundle._id&&f._post&&f._post.pointValue>0);
            const feedItemsWithPointsAwarded = feedItemsWithPoints.filter(f=>f.pointsAwarded);
            const possiblePoints = feedItemsWithPoints.reduce((accumulator, feedItem) => accumulator + feedItem._post.pointValue, 0);
            const pointsAwarded = feedItemsWithPointsAwarded.reduce((accumulator, feedItem) => accumulator + feedItem.pointsAwarded, 0);
            return <li key={bundle._id} aria-label={`${bundle.fullName}`}><BundleCard
                actionWord={"Watch the video"}
                bundle={bundle}
                onClick={props.onSelectBundle}
                possiblePoints={possiblePoints}
                pointsAwarded={pointsAwarded}
            /></li>;
          })}
        </ul>
      </div>
    </div>
  </PrimaryLayout>
;
